import { render } from "./dietaryguidanceDetail.vue?vue&type=template&id=7b2ee6b1&scoped=true"
import script from "./dietaryguidanceDetail.vue?vue&type=script&lang=js"
export * from "./dietaryguidanceDetail.vue?vue&type=script&lang=js"

import "./dietaryguidanceDetail.vue?vue&type=style&index=0&id=7b2ee6b1&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ee6b1"]])

export default __exports__